import {
  ShowcaseApi,
  ShowcaseCategoryApi,
} from '../../services/sub-services/event-showcase.service/type';
import { EventShowcaseCategoryType, ShowcaseModelType } from './types';

export const EventShowcaseCategoryModel = (
  data: ShowcaseCategoryApi,
): EventShowcaseCategoryType => ({
  id: data?.id ?? 0,
  name: data?.name ?? '',
  description: data?.description ?? '',
  featureImage: data?.feature_image ?? '',
  showcases:
    data?.showcases?.map((showcase) => ({
      id: showcase.id,
      name: showcase.name,
      description: showcase.description,
      featureImage: showcase.feature_image,
      images: showcase.images,
      videos: showcase.videos,
    })) ?? [],
});

export const EventShowcaseCategoryListModel = (
  data: ShowcaseCategoryApi[],
): EventShowcaseCategoryType[] => {
  return data.map((item) => EventShowcaseCategoryModel(item));
};

export const EventShowcaseModel = (data: ShowcaseApi): ShowcaseModelType => ({
  id: data?.id ?? 0,
  name: data?.name ?? '',
  description: data?.description ?? '',
  featureImage: data?.feature_image ?? '',
  images: data?.images ?? [],
  videos: data?.videos ?? [],
});
